import React from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
/**
 * Thin wrapper around react-datepicker that exposes a consistent prop interface.
 *
 * @param {Object} props
 * @param {Date|null} props.selected - The currently selected date value.
 * @param {Function} props.onChange - Called with the new Date when the user selects one.
 * @param {boolean} [props.showTimeSelect=false] - Whether to show a time selector alongside the calendar.
 * @returns {JSX.Element}
 */
const ReactDatePicker = ({ selected, onChange, showTimeSelect = false, ...props}) => {
    return (
        <DatePicker {...props} selected={selected} onChange={onChange} showTimeSelect={showTimeSelect} />
    );
}

export default ReactDatePicker